import './financing/entities/ChancenDynamicClassFormOfFinanzing.js';
import './financing/entities/ChancenDynamicClassFormOfFinanzingFilter.js';
import './financing/entities/FormOfFinancing.js';
import './financing/entities/FormOfFinancingBuT.js';
import './financing/entities/FormOfFinancingMitgliedsbeitrag.js';
import './financing/entities/FormOfFinancingStiftungsgeld.js';
import './products/entities/Capacity.js';
import './products/entities/ChancenDynamicClassProduct.js';
import './products/entities/ChancenDynamicClassProductFilter.js';
import './products/entities/ProductCHF.js';
import './products/entities/ProductLKK.js';
import './products/entities/ProductSCH.js';
import './products/entities/ProductLUS.js';
